// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3VPao","container":"styles_container__hdeTp","title":"styles_title__bRCZR","wrapper":"styles_wrapper__3T2vN","answer":"styles_answer__1n-dV"};